import { RootState } from "@/app/stores"
import { getProcessingTransactions, IGetProcessingTransactionsResults } from "@/shared/api/bonuses"
import { getCommunityTransactions } from "@/shared/api/community"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchSocialProgramProcessingTransactions = createAsyncThunk<
    IGetProcessingTransactionsResults,
    void,
    { state: RootState }
>('socialProgramProcessingTransactions/fetchSocialProgramProcessingTransactions', async (_, thunkAPI) => {
    try {
        const { page, limit, startDate, endDate, bonusId } = thunkAPI.getState().socialProgramProcessingTransactions
        const data = await getProcessingTransactions(page, limit, startDate, endDate, bonusId, "social")
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})